export const PAGE_SIZE = 25;
export const SORT = ["profile_ranking:asc"];
